


























































import { Component, Vue } from "vue-property-decorator";
import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import axios from "@/api/AuthAPI/auth-request-api";
import { auth } from "@/config/host.config";
import { AxiosResponse } from "axios";

interface IMail {
  staff: string;
  message: string;
  page: string;
}

@Component({
  components: { SubmitResetButtonGroop },
})
export default class Support extends Vue {
  identifier =
    this.$store.getters.getUserRole + "$" + sessionStorage.getItem("login");
  name = "";
  message = "";
  page = "";

  show = false;

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();

    const newMail: IMail = {
      staff: this.name,
      message: this.message,
      page: this.page,
    };

    console.log(JSON.stringify(newMail));
    this.sendNewMail(newMail);
  }

  onReset(): void {
    this.name = "";
    this.message = "";
    this.page = "";
  }

  async sendNewMail(mail: IMail): Promise<void> {
    const uri = auth.support;
    const sendMail: AxiosResponse = await axios.post(uri, mail);

    if (sendMail.status === 200) {
      this.show = true;
      this.onReset();
      setTimeout(() => {
        this.show = false;
      }, this.$second(3));
    }
  }
}
